import first from './1.jpg';
import second from './2.jpg';
import third from './3.jpg';
import fourth from './4.jpg';

export default [
    { image: first, url: 'https://www.ochkov.net/kontaktniye-linzy/' },
    { image: second, url: 'https://www.ochkov.net/ochki/' },
    { image: third, url: 'https://www.ochkov.net/ochki/' },
    { image: fourth, url: 'https://www.ochkov.net/kontaktniye-linzy/' },
];
